<template>
  <div :class="{'check-box': true, 'disabled': disabled, 'smaller': smaller, 'checked': checked}" @click="onCheckboxClicked()">
    <span v-show="updating || checked" class="check-mark" :class="{updating: updating}">✘</span>
  </div>
</template>


<script>
export default {
  name: "BallotBox",
  props: ['selected', 'disabled', 'smaller'],
  emits: ['checked', 'unchecked'],
  data() {
    return {
      checked: !!this.selected,
      updating: false,
    }
  },

  watch: {
    selected(newValue /*, oldValue*/) {
      this.checked = newValue;
      this.updating = false;
    },
  },

  mounted() {
  },

  methods: {

    onCheckboxClicked() {
      this.updating = true;
      this.$emit(!this.checked ? 'checked' : 'unchecked'); // emit the opposite
    },

    setCheckboxState(_checked) {
      this.checked = _checked;
      this.updating = false;
    }
  }
}
</script>


<style scoped>


.check-box {
  position: relative;
  display: inline-block;
  margin-top: 0.375em;
  height: 1.5em;
  width: 1.5em;
  border-style: solid;
  border-width: thin;

  &.smaller {
    height: 1.35em;
    width: 1.35em;
  }

  .check-mark {
    color: var(--bs-body-color);
    opacity: 80%;
    font-size: 3em;
    position: absolute;
    left: -0.135em;
    top: -0.6em;

    &.updating {
      animation: pulse 250ms infinite;
    }
  }
  cursor: pointer;

  &.disabled {
    pointer-events: none;

    &:not(.checked) {
      border-color: gainsboro;
    }
  }
}

@keyframes pulse {
  0% {opacity: 55%;}
  50% {opacity: 45%;}
  100% {opacity: 55%;}
}
</style>